import { render, staticRenderFns } from "./ButtonArrow.vue?vue&type=template&id=d9845a56&scoped=true"
import script from "./ButtonArrow.vue?vue&type=script&lang=js"
export * from "./ButtonArrow.vue?vue&type=script&lang=js"
import style0 from "./ButtonArrow.vue?vue&type=style&index=0&id=d9845a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9845a56",
  null
  
)

export default component.exports